import { clsx } from 'clsx'

import { BillingPriceInterval } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'

interface Props {
  billingInterval: BillingPriceInterval
  onChange: (interval: BillingPriceInterval) => void
}

export const BillingIntervalToggle = ({ billingInterval, onChange }: Props) => {
  return (
    <div className="flex flex-col items-center bg-surface rounded-card shadow-card">
      <div className="flex text-basicSurface-900 p-1.5 space-x-2">
        <div
          className={clsx(
            billingInterval === BillingPriceInterval.Month &&
              'bg-surface-pressed',
            'text-center rounded-card cursor-pointer py-2 px-4 font-medium',
          )}
          onClick={() => onChange(BillingPriceInterval.Month)}
        >
          <T defaultMessage="Monthly" id="Admin.Billing.Plans.Monthly" />
        </div>
        <div
          className={clsx(
            billingInterval === BillingPriceInterval.Year &&
              'bg-surface-pressed',
            'text-center rounded-card cursor-pointer py-2 px-4 flex gap-2 font-medium',
          )}
          onClick={() => onChange(BillingPriceInterval.Year)}
        >
          <T defaultMessage="Yearly" id="Admin.Billing.Plans.Yearly" />
          <Badge variant="positive">
            <T defaultMessage="Save 20%" id="Admin.Billing.Plans.Save" />
          </Badge>
        </div>
      </div>
    </div>
  )
}
